import { useAxios } from "@hooks"
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ExamGroup } from "@types";

export const useGetExamGroups = (id?: string, examPeriodScreen?: boolean) => {

    const axios = useAxios();
    const {t} = useTranslation();

    const getExamGroups = async (id?: string) => {
        try {
            if (!examPeriodScreen) {
                const response = await axios.get<ExamGroup[]>(`/api/exam/${id}/groups`);
                return response.data;
            } else {
                const response = await axios.get<ExamGroup[]>(`/api/ExamTerms/${id}/groups`);
                return response.data;
            }
            
        } catch (error) {
            throw new Error(t("messages.error.getExamGroups"));
        }
    }

    return useQuery({queryKey: ["examGroups", id, examPeriodScreen], queryFn: () => getExamGroups(id), staleTime: Infinity})
}